import { ImageLocation, StoreStatus } from './imageStores'

export enum ImagePageTabs {
  Images = 'images',
  Snapshots = 'snapshots',
}

export interface ImagesResponse {
  images: Image[]
  first: string
  schema: string
}

export interface Image {
  bdm_v2?: string
  root_device_name?: string
  owner_user_name?: string
  owner_project_name?: string
  hw_vif_model?: string
  hw_video_model?: string
  hw_pointer_model?: string
  hw_machine_type?: string
  hw_input_bus?: string
  hw_disk_bus?: string
  hw_cdrom_bus?: string
  boot_roles?: string
  block_device_mapping?: string
  base_image_ref?: string
  name: string
  disk_format: string
  container_format: string
  visibility: string
  size: number
  virtual_size: number | null
  status: string
  checksum: string
  protected: boolean
  min_ram: number
  min_disk: number
  owner: string
  os_hidden: boolean
  os_hash_algo: string
  os_hash_value: string
  // Where the image data physically resides — authoritative source for the Stores column. The
  // Glance public endpoint returns this (each entry carries metadata.store); the derived `stores`
  // string is admin-endpoint only, so we do not rely on it.
  locations?: ImageLocation[]
  os_glance_importing_to_stores?: string
  os_glance_failed_import?: string
  id: string
  created_at: Date
  updated_at: Date
  tags: any[]
  self: string
  file: string
  schema: string
  os_type?: string
}

export interface ImagesSelector extends Image {
  imageType: 'image' | 'ephemeralDiskSnapshot' | 'vmVolumeSnapshot'
  imageTypeDisplay: string
  snapshotIds: string[]
  properties: any
  storeStatuses: StoreStatus[]
}
